import * as React from 'react';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '../Components/Typography';
import SupportOutlinedIcon from '@mui/icons-material/SupportOutlined';

export const ContactUs = () => {
	return (
		<Container
			component="section"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				my: 9,
			}}
		>
			<Button
				sx={{
					border: '4px solid currentColor',
					borderRadius: 0,
					height: 'auto',
					py: 2,
					px: 5,
				}}
			>
				<Typography variant="h4" component="span">
					Got any questions? Need help?
				</Typography>
			</Button>
			<Typography variant="subtitle1" sx={{ my: 3 }}>
				We are here to help. Get in touch!
			</Typography>
			<SupportOutlinedIcon sx={{ fontSize: 70 }} />
		</Container>
	);
};

//export default ProductSmokingHero;
